//Interfaces

export interface MessageItem {
    id: number,
    type: number,
    createTime: string,
    content: string,
    status: number,
    attachment: string,
    activityName: string
}
export interface TabItem {
    name: string,
    notice_type: number,
    value: number
}

export interface MessageData {
    tabList: any[]
    totalMsg: number
    pageSize: number
    pageNo: number
    activeTab: TabItem
    noticeList: MessageItem[]
}

//  Constants
export const PAGE_SIZE = 20;

export const TAB_LIST = ([
    { name: 'message.unread', notice_type: 5, value: 0 },
    { name: 'message.all', notice_type: 0, value: 1 },
    { name: 'message.system', notice_type: 1, value: 2 },
    { name: 'message.deposit', notice_type: 2, value: 3 },
    { name: 'message.withdraw', notice_type: 3, value: 4 },
    { name: 'message.bonus', notice_type: 4, value: 5 },])

